'use es6';

import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePrevious } from '../../hooks/usePrevious';
import { HSAnalyticsContext } from './HSAnalyticsContext';

const HSPageViewTracker = ({
  pathname
}) => {
  const prevPathname = usePrevious(pathname);
  const {
    initialPageLoad,
    setInitialPageLoad
  } = useContext(HSAnalyticsContext);
  useEffect(() => {
    if (!initialPageLoad && pathname !== prevPathname) {
      const _hsq = window._hsq = window._hsq || [];

      _hsq.push(['setPath', pathname]);

      _hsq.push(['trackPageView']);
    }

    setInitialPageLoad(false);
  }, [initialPageLoad, pathname, prevPathname, setInitialPageLoad]);
  return null;
};

HSPageViewTracker.propTypes = {
  pathname: PropTypes.string.isRequired
};
export default HSPageViewTracker;